import clsx from 'clsx';
import { FC, ReactNode } from 'react';

interface ButtonProps {
  className?: string;
  children: ReactNode;
}

export const Button: FC<ButtonProps> = ({ className, children, ...props }) => {
  const buttonClassName = clsx(
    'vtmn-h-6 vtmn-flex vtmn-justify-center vtmn-items-center vtmn-rounded',
    className
  );
  return (
    <button
      data-testid="button-component"
      className={buttonClassName}
      {...props}
    >
      {children}
    </button>
  );
};
